import { render, staticRenderFns } from "./OverflowFade.vue?vue&type=template&id=31003db6&scoped=true&"
import script from "./OverflowFade.vue?vue&type=script&lang=ts&"
export * from "./OverflowFade.vue?vue&type=script&lang=ts&"
import style0 from "./OverflowFade.vue?vue&type=style&index=0&id=31003db6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31003db6",
  null
  
)

export default component.exports